import { render, staticRenderFns } from "./Procedimentos.vue?vue&type=template&id=79dd3c3a"
import script from "./Procedimentos.vue?vue&type=script&lang=js"
export * from "./Procedimentos.vue?vue&type=script&lang=js"
import style0 from "./Procedimentos.vue?vue&type=style&index=0&id=79dd3c3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports